<template>
  <a-card class="card-container">
    <a-row :gutter="gutter">
      <a-col :span="6" class="label">找人需求:</a-col>
      <a-col :span="18" class="value">{{ dataInfo.reason }}</a-col>
    </a-row>
    <a-row :gutter="gutter">
      <a-col :span="6" class="label">发起人:</a-col>
      <a-col :span="12">{{ dataInfo.createByName }}</a-col>
    </a-row>
    <a-row :gutter="gutter">
      <a-col :span="6" class="label">反馈人:</a-col>
      <a-col :span="12">{{ dataInfo.receiveName }}</a-col>
    </a-row>
    <a-row :gutter="gutter">
      <a-col :span="6" class="label">反馈记录:</a-col>
      <a-col :span="12">{{ getFamiliarityLabel(dataInfo.familiarity) }}</a-col>
    </a-row>

    <a-form layout="horizontal" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" class="form">
      <a-form-item label="人才连接记录">
        <a-textarea v-model="dataInfo.info" placeholder="写点想记录的吧" :disabled="disabled" :auto-size="{ minRows: 3, maxRows: 6 }"></a-textarea>
      </a-form-item>
      <a-form-item label="激励方式记录">
        <a-textarea
          v-model="dataInfo.reward"
          :disabled="disabled"
          placeholder="想要用什么方式激励ta都可以，记录一下吧"
          :auto-size="{ minRows: 3, maxRows: 6 }"
        ></a-textarea>
      </a-form-item>
      <a-form-item v-if="!disabled" :wrapper-col="{ md: { offset: 5, span: 12 } }">
        <a-button type="primary" @click="submit" class="submit" :loading="loading">提交</a-button>
      </a-form-item>
    </a-form>
  </a-card>
</template>
<script>
import { familiarityOptions } from './components/constants';
import { queryFeedbackInfo, commitFeedbackInfo } from '@/api/humint';
export default {
  data() {
    return {
      familiarityOptions,
      disabled: true,
      id: '',
      loading: false,
      gutter: [8, 12],
      dataInfo: {
        reason: '',
        createByName: '',
        receiveName: '',
        familiarity: '',
        info: '',
        reward: ''
      }
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getInfo();
  },
  methods: {
    getFamiliarityLabel(value) {
      let label = '';
      familiarityOptions.forEach(item => {
        if (item.value === value) {
          label = item.label;
        }
      });
      return label;
    },
    async getInfo() {
      try {
        let res = await queryFeedbackInfo({
          id: this.id
        });
        if (res.code === 200) {
          this.dataInfo = res.data;
          if (this.dataInfo.info || this.dataInfo.reward) {
            this.disabled = true;
          } else {
            this.disabled = false;
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async submit() {
      if (this.loading) return;

      if (!this.dataInfo.info) {
        this.$message.error('请填写反馈记录');

        return;
      }
      if (!this.dataInfo.reward) {
        this.$message.error('请填写激励方式记录');
        return;
      }
      this.loading = true;
      try {
        let res = await commitFeedbackInfo({
          id: this.id,
          info: this.dataInfo.info,
          reward: this.dataInfo.reward
        });
        if (res.code === 200) {
          this.disabled = true;
          this.$message.success('提交成功');
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.submit {
  width: 100%;

  @media only screen and (max-width: 768px) {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }
}
.form {
  margin-top: 15px;
}
.label {
  text-align: right;
  color: rgba(0, 0, 0, 0.85);
  padding-right: 10px;
  font-weight: normal;
  font-style: normal;
}
.value {
  word-break: break-all;
}
.card-container {
  margin-bottom: 15px;
}
</style>
